import Microgame from '../engine/Microgame.js';

export default class MatchGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Paires !`, en: `Match!`, es: `¡Combina!` },
            controls: { fr: `Appuie sur deux objets identiques`, en: `Tap on two identical objects`, es: `Toca dos objetos idénticos` },
            objective: { fr: `Relie les bonnes paires`, en: `Match the correct pairs`, es: `Encuentra el par correcto` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M4 10h16M4 14h16M10 4v16M14 4v16"/></svg>`,
            actions: [
                { type: 'wait', duration: 300 },
                { type: 'tapTarget', selector: '[data-playback-correct="true"]', duration: 220 },
                { type: 'wait', duration: 700 },
            ],
            loopDuration: 2200
        };
    }
    constructor(engine) {
        super(engine);
        this.shapes = ['■', '▲', '●', '★'];
        this.colors = [this.primaryColor, this.secondaryColor];
        this.target = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "MATCH!";
        this.startRound();
    }

    startRound() {
        // Clear previous
        this.container.innerHTML = '';

        // Random Target
        const shape = this.isPlayback ? this.shapes[0] : this.shapes[Math.floor(Math.random() * this.shapes.length)];
        const color = this.isPlayback ? this.colors[0] : this.colors[Math.floor(Math.random() * this.colors.length)];
        this.target = { shape, color };

        // Display Target
        const targetEl = document.createElement('div');
        targetEl.textContent = shape;
        targetEl.style.color = color;
        targetEl.style.fontSize = '80px';
        targetEl.style.position = 'absolute';
        targetEl.style.top = '30%';
        targetEl.style.left = '50%';
        targetEl.style.transform = 'translate(-50%, -50%)';
        targetEl.style.textShadow = `0 0 20px ${color}`;
        this.container.appendChild(targetEl);

        // Options Container (Just for containment, not layout)
        const optionsContainer = document.createElement('div');
        optionsContainer.style.position = 'absolute';
        optionsContainer.style.bottom = '20%';
        optionsContainer.style.width = '100%';
        optionsContainer.style.height = '100px';
        this.container.appendChild(optionsContainer);

        // Generate Options (1 correct, 2 wrong)
        const options = [this.target];
        while (options.length < 3) {
            const s = this.shapes[Math.floor(Math.random() * this.shapes.length)];
            const c = this.colors[Math.floor(Math.random() * this.colors.length)];
            // Avoid duplicates
            if (!options.some(o => o.shape === s && o.color === c)) {
                options.push({ shape: s, color: c });
            }
        }

        // Shuffle
        if (!this.isPlayback) options.sort(() => Math.random() - 0.5);

        // Render Options with Fixed Positions
        const positions = ['20%', '50%', '80%'];

        options.forEach((opt, idx) => {
            const btn = document.createElement('div');
            btn.textContent = opt.shape;
            btn.style.color = opt.color;
            btn.style.fontSize = '60px';
            btn.style.cursor = 'pointer';
            btn.style.width = '80px';
            btn.style.height = '80px';
            btn.style.display = 'flex';
            btn.style.alignItems = 'center';
            btn.style.justifyContent = 'center';
            btn.style.position = 'absolute';
            btn.style.left = positions[idx];
            btn.style.top = '0';
            btn.style.transform = 'translateX(-50%)'; // Center on the position
            btn.style.border = '2px solid #333';
            btn.style.borderRadius = '10px';
            btn.style.background = 'rgba(0,0,0,0.5)';
            if (opt.shape === this.target.shape && opt.color === this.target.color) {
                btn.dataset.playbackCorrect = 'true';
            }

            btn.addEventListener('pointerdown', (e) => {
                if (!this.active) return;

                if (opt.shape === this.target.shape && opt.color === this.target.color) {
                    // Infinite / Time Attack Logic
                    if (this.engine.activeChallenge && (this.engine.activeChallenge.mode === 'infinite' || (this.engine.activeChallenge.config && this.engine.activeChallenge.config.timeAttack))) {
                        this.engine.score++;
                        this.engine.updateHUD();
                        this.startRound(); // New round immediately
                    } else {
                        this.win();
                    }
                } else {
                    this.lose();
                }
            });

            optionsContainer.appendChild(btn);
        });
    }
}
